import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import SampleProducts from "../../components/SampleProducts";
import "./ReadymadeTechs.css";

export default function ReadymadeTechs() {

  const navigate = useNavigate();

 const remainingProducts =
  SampleProducts.filter(product => !product.featured);


  const goToProduct = (id) => {
    navigate(`/business-product/${id}`);
  };

  return (
    <div className="readymade-page">

    <div className="readymade-header">
      {/* ✅ Back Button */}
      <button
        className="readymade-back-btn"
        onClick={() => navigate(`/mind-mapping/sec-b`)}
      >
        <FaArrowLeft />
      </button>

      <h1 className="readymade-title">
        Ready Made Tech's
      </h1>
      </div>

      {/* ✅ BULLET LIST */}
      <ul className="readymade-list">
        {remainingProducts.map((product) => (
          <li
            key={product.id}
            onClick={() => goToProduct(product.id)}
          >
            {product.name}
          </li>
        ))}
      </ul>

    </div>
  );
}
